/**
 * Enum for Feature Flag Ids
 * see this link for more info https://sprouthq.atlassian.net/l/cp/mh1twVAx
 * @readonly
 * @enum {name: {value: number}}
 */
export const FeatureFlagIdEnum = Object.freeze({
  azureAttendanceReport: 1,
  preComputedAttendance: 2,
  forceComputation: 4,
  dateTagging: 5,
  newCarryOver: 6,
  zendeskSupport: 7,
  leaveReportOptimization: 8,
  prepaidHmo: 9,
  mobileAppV2: 10,
  mobileDeviceRegistration: 11,
  mobileDeviceJailBrokenValidation: 12,
  loansIFrameHidden: 13,
  authenticationModule: 15,
  temperatureMonitoring: 16,
  multiServerDatabase: 17,
  dtsCompressed: 18,
  allowWebServiceIntegration: 19,
  instaCashMobile: 20,
  dailyPulse: 21,
  hrPerfProSso: 22,
  changeTemporaryPassword: 23,
  saveAttendanceReportToCache: 24,
  performanceProEmployeeSync: 25,
  nextDayRdComputation: 26,
  leavesForMobile: 27,
  officialBusinessForMobile: 28,
  overtimeForMobile: 29,
  undertimeForMobile: 30,
  scheduleAdjustmentForMobile: 31,
  certificateOfAttendanceForMobile: 32,
  announcementModule: 33,
  futureDatedResignation: 34,
  notificationEngine: 35,
  projectTagging: 36,
  jobRequestModule: 37,
  salaryHistory: 40,
  attendanceManager: 41,
  dtsEmployeeScheduleGet: 50,
  employeeSyncHrAndPayrollApi: 51,
  dateTaggingEmployeeScheduleGetPhase2: 52,
  dateTaggingEmployeeScheduleAdjustmentGet: 53,
  mobileBundy: 54,
  useApiApprovalActions: 55,
  pushNotification: 56,
  enableSSO: 57,
  bulkUtility: 58,
  instacashId1: 14,
  instcashId2: 3,
  enableFintechNavigation: 44,
});
